module.exports = __webpack_public_path__ + "assets/img/desc-04-5977a75c.png";